import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, CardContent, Divider, Fade } from '@material-ui/core';
import cx from 'clsx';
import cloneDeep from 'lodash/cloneDeep';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { uniqueKey } from '../../utils';
import { Questionnaire } from '../Questionnaire';
import { AnswerActions } from './AnswerActions';
import { AnswerCarousel, getPageIndex } from './AnswerCarousel';
import { AnswerContent } from './AnswerContent';
import { getOperatorEscalationUrl } from './getOperatorEscalationUrl';
import { buildSelectionPath, generateOrderedAnswersExcludeAnotherCards } from './utils';
var dividerStyle = { marginTop: 12, marginBottom: 12 };
function isRootCard(answer, cardId) {
    return answer.id === cardId;
}
function isCarouselCard(answer) {
    return answer.contents.some(function (c) { return Boolean(c.carousel); });
}
export function Answer(_a) {
    var contents = _a.contents, onClick = _a.onClick, cardId = _a.cardId, answers = _a.answers, operatorEscalationKeyword = _a.operatorEscalationKeyword, karakuriWebRootUrl = _a.karakuriWebRootUrl, messages = _a.messages, info = _a.info, session = _a.session, onFeedback = _a.onFeedback, skillApi = _a.skillApi;
    var _b = useState([cardId]), selectionPath = _b[0], setSelectionPath = _b[1];
    var _c = useMemo(function () {
        var actionList = [];
        var keyAssignmentAnswers = {};
        var actionActionMap = {};
        var defaultSelectSelectionState = {};
        answers.forEach(function (answer) {
            var _a;
            var actionActionIds = (((_a = answer === null || answer === void 0 ? void 0 : answer.actions) === null || _a === void 0 ? void 0 : _a.actions) || []).map(function (action) { return (action === null || action === void 0 ? void 0 : action.id) || ''; });
            actionList.push(actionActionIds);
            keyAssignmentAnswers[answer.id] = answer;
            var isAnswerSelect = actionActionIds.length > 0;
            if (isAnswerSelect) {
                // 選択肢ありカードの場合、answer.idとanswer.actions.idは同じ
                defaultSelectSelectionState[answer.id] = {
                    currentActionActionId: undefined,
                    actionIds: actionActionIds,
                };
                actionActionIds.forEach(function (actionActionId) {
                    actionActionMap[actionActionId] = answer.id;
                });
            }
        });
        var orderedAnswers = generateOrderedAnswersExcludeAnotherCards(keyAssignmentAnswers, [
            cardId,
        ]);
        return [keyAssignmentAnswers, orderedAnswers, defaultSelectSelectionState, actionActionMap];
    }, [answers, cardId]), keyAssignmentAnswers = _c[0], orderedAnswers = _c[1], defaultSelectSelectionState = _c[2], actionActionMap = _c[3];
    var _d = useState({}), carouselSelectionState = _d[0], setCarouselSelectionState = _d[1];
    var _e = useState({}), selectSelectionState = _e[0], setSelectSelectionState = _e[1];
    useEffect(function () {
        setSelectionPath([cardId]);
    }, [cardId]);
    var ensureSelectSelectionState = function (actionActionId) {
        var cloneSelectSelectionState = cloneDeep(selectSelectionState);
        var actionId = actionActionMap[actionActionId];
        if (!cloneSelectSelectionState[actionId]) {
            cloneSelectSelectionState[actionId] = defaultSelectSelectionState[actionId];
        }
        return cloneSelectSelectionState;
    };
    var updateSelectionPath = function (data) {
        if (data.carousel) {
            setSelectionPath(buildSelectionPath(cardId, keyAssignmentAnswers, data.carousel, selectSelectionState));
        }
        if (data.select) {
            setSelectionPath(buildSelectionPath(cardId, keyAssignmentAnswers, carouselSelectionState, data.select));
        }
    };
    var updateSelectActionActionId = function (actionActionId) {
        var ensuredSelectSelectionState = ensureSelectSelectionState(actionActionId);
        var actionId = actionActionMap[actionActionId];
        ensuredSelectSelectionState[actionId].currentActionActionId = actionActionId;
        setSelectSelectionState(ensuredSelectSelectionState);
        updateSelectionPath({ select: ensuredSelectSelectionState });
    };
    var onActionSelected = function (e, id, external, uri) {
        e.preventDefault();
        if (external) {
            if (uri) {
                return window.open(uri, '_blank', 'noopener,status=yes,scrollbars=yes,resizable=yes');
            }
            onClick("/answer/".concat(id));
        }
        else {
            updateSelectActionActionId(id);
        }
    };
    return (_jsxs("div", { className: "faq-answer-content-wrapper", children: [_jsxs(CardContent, { className: cx('faq-answer-content'), children: [_jsx(Avatar, { "aria-label": "Answer", className: cx('faq-answer-a', 'faq-answer-content__a'), children: info ? 'i' : 'A' }), contents && (_jsx(AnswerContent, { cardId: cardId, className: "faq-answer-content__answer", contents: contents, skillApi: skillApi }))] }), orderedAnswers && orderedAnswers.length > 0
                ? orderedAnswers.map(function (a) {
                    if (!selectionPath.includes(a.id)) {
                        return null;
                    }
                    else if (isRootCard(a, cardId)) {
                        if (isCarouselCard(a)) {
                            return (_jsx(Fragment, { children: a.contents.map(function (c) {
                                    return c.carousel ? (_jsx(AnswerCarousel, { index: getPageIndex(c.carousel.id, carouselSelectionState), baseClassName: "faq-answer-content__answer", carousel: c.carousel, skillApi: skillApi, answers: orderedAnswers, cardId: cardId, onClick: onClick, selectionPath: selectionPath, updateSelectionPath: updateSelectionPath, carouselSelectionState: carouselSelectionState, setCarouselSelectionState: function (state) { return setCarouselSelectionState(state); }, operatorEscalationKeyword: operatorEscalationKeyword, karakuriWebRootUrl: karakuriWebRootUrl, session: session }, uniqueKey('answer-carousel', cardId, a.id, c.carousel.id))) : null;
                                }) }, uniqueKey('fragment-answer', cardId, a.id)));
                        }
                        else {
                            return (_jsx(AnswerActions, { className: "faq-answer-content__button", cardId: cardId, answers: orderedAnswers, actions: a.actions || null, selectionPath: selectionPath, operatorEscalationKeyword: operatorEscalationKeyword, karakuriWebRootUrl: karakuriWebRootUrl, onActionSelected: onActionSelected, session: session }, uniqueKey('answer-actions', cardId, a.id)));
                        }
                    }
                    else {
                        /* isChildCard */
                        return (_jsx(Fade, { in: selectionPath.includes(a.id), children: _jsxs(_Fragment, { children: [_jsx(Divider, { variant: "middle", light: true, style: dividerStyle }, uniqueKey('fade-divider-answer', cardId, a.id)), _jsx(AnswerContent, { cardId: cardId, className: "faq-answer-content__answer", contents: a.contents, skillApi: skillApi }, uniqueKey('fade-answer-content', cardId, a.id)), isCarouselCard(a) &&
                                        a.contents.map(function (c) {
                                            return c.carousel ? (_jsx(AnswerCarousel, { index: getPageIndex(c.carousel.id, carouselSelectionState), baseClassName: "faq-answer-content__answer", carousel: c.carousel, skillApi: skillApi, answers: orderedAnswers, cardId: cardId, onClick: onClick, selectionPath: selectionPath, updateSelectionPath: updateSelectionPath, carouselSelectionState: carouselSelectionState, setCarouselSelectionState: function (state) { return setCarouselSelectionState(state); }, operatorEscalationKeyword: operatorEscalationKeyword, karakuriWebRootUrl: karakuriWebRootUrl, session: session }, uniqueKey('answer-carousel', cardId, a.id, c.carousel.id))) : null;
                                        }), !isCarouselCard(a) && (_jsx(AnswerActions, { className: "faq-answer-content__button", cardId: cardId, answers: orderedAnswers, actions: a.actions || null, selectionPath: selectionPath, operatorEscalationKeyword: operatorEscalationKeyword, karakuriWebRootUrl: karakuriWebRootUrl, onActionSelected: onActionSelected, session: session }, uniqueKey('answer-actions', cardId, a.id)))] }) }, uniqueKey('fade-answer', cardId, a.id)));
                    }
                })
                : null, !info && (_jsx(CardContent, { children: _jsx(Questionnaire, { cardId: cardId, onFeedback: onFeedback, messages: messages, operatorEscalationUrl: getOperatorEscalationUrl(cardId, orderedAnswers || [], selectionPath, karakuriWebRootUrl, operatorEscalationKeyword, session), skillApi: skillApi }) }))] }));
}
//# sourceMappingURL=Answer.js.map